var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"grid",staticClass:"grid",style:({backgroundImage: ("url('" + _vm.svg + "'")})})}
var staticRenderFns = []

export { render, staticRenderFns }